import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Collapse,
  Row,
  Space,
  Tooltip,
  Typography,
} from "antd";
import { useResponsive } from "../../utils/use-responsive";
import {
  PlusOutlined,
  QuestionCircleFilled,
  UpOutlined,
} from "@ant-design/icons";
import styles from "./connection-card-modal.module.scss";

const { Panel } = Collapse;
const { Title, Text } = Typography;

export const CustomerActivityCard: React.FC<{
  title: string;
  tooltip: string;
  icon: string;
  details: string;
  extras?: Object;
  optional?: boolean;
  button?: string;
}> = ({
  title,
  tooltip,
  icon,
  details,
  extras = false,
  optional = false,
  button,
}) => {
  const { isXs } = useResponsive();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  function showOptionalOrIcon() {
    if (!isXs && !optional) {
      return (
        <div className={styles["cardIcon"]}>
          <img alt="Icon" src={icon} />
        </div>
      );
    } else if (!isXs && optional) {
      return (
        <Row justify="space-between">
          <img alt="Icon" src={icon} />
          <Text type="secondary">Optional</Text>
        </Row>
      );
    }
  }

  return (
    <Col xs={24} sm={12} md={12} lg={12} xl={12}>
      <Card style={{ borderRadius: "8px" }}>
        <Space direction={"vertical"} size={"middle"} className={"full-width"}>
          <Row typeof="flex" justify="space-between" className={"full-width"}>
            <Col typeof="flex" className={!isXs ? "" : "full-width"}>
              <Space.Compact direction={"vertical"} className={"full-width"}>
                <Space
                  direction={!isXs ? "vertical" : "horizontal"}
                  size={"small"}
                  className={"ant-row-space-between"}
                  style={{ rowGap: "15px" }}
                >
                  {showOptionalOrIcon()}

                  {!isXs && (
                    <Text type="secondary" style={{ margin: 0 }}>
                      Activity
                    </Text>
                  )}
                  {isXs && (
                    <Button
                      className="requestStatement"
                      block
                      type="primary"
                      size="large"
                    >
                      Request statement
                    </Button>
                  )}
                  {isXs && !optional && <img alt="Icon" src={icon} />}
                </Space>
              </Space.Compact>
            </Col>
            <Col typeof="flex">
              <Space direction={"vertical"} style={{ rowGap: "0px" }}>
                {!isXs && (
                  <Button
                    className="requestStatement"
                    block
                    type="primary"
                    size="large"
                  >
                    Request statement
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <Space.Compact direction={"vertical"} className={"full-width"}>
            {/*  */}
            <ul>
              <li>
                <span>
                  <Title level={3} style={{ margin: 0, fontWeight: "lighter" }}>
                    Monthly service fee
                  </Title>
                  <Text type="secondary" style={{ margin: 0 }}>
                    1 June 2024
                  </Text>
                </span>
                <span className={"extras"}>- €600.00</span>
              </li>

              <li>
                <span>
                  <Title level={3} style={{ margin: 0, fontWeight: "lighter" }}>
                    Repayment €5,400.00
                  </Title>
                  <Text type="secondary" style={{ margin: 0 }}>
                    1 June 2024
                  </Text>
                </span>
                <span className={"extras"}>- €5,400.00</span>
              </li>

              <li>
                <span>
                  <Title level={3} style={{ margin: 0, fontWeight: "lighter" }}>
                    Principle advance 100,000.00{" "}
                    <Tooltip
                      placement="top"
                      title={
                        "This is your initial funding amount minus the €3,750.00 (1.5%) facility fee."
                      }
                    >
                      <QuestionCircleFilled style={{ fontSize: "18px" }} />
                    </Tooltip>
                  </Title>
                  <Text type="secondary" style={{ margin: 0 }}>
                    1 May 2024
                  </Text>
                </span>
                <span className={"extras"}>+ €97,000.00</span>
              </li>
            </ul>
          </Space.Compact>
        </Space>
      </Card>
    </Col>
  );
};
